// extracted by mini-css-extract-plugin
module.exports = {"flag":"style_flag__2aE0-"};